import { render, staticRenderFns } from "./yieldDetailTabsTwo.vue?vue&type=template&id=2e4338e0&scoped=true&"
import script from "./yieldDetailTabsTwo.vue?vue&type=script&lang=js&"
export * from "./yieldDetailTabsTwo.vue?vue&type=script&lang=js&"
import style0 from "./yieldDetailTabsTwo.vue?vue&type=style&index=0&id=2e4338e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4338e0",
  null
  
)

export default component.exports